(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('leanSyncAddField', leanSyncAddField);

	leanSyncAddField.$inject = ['$rootScope', '$scope', '$filter', '$timeout',
		'$compile', '$uibModal', 'leanSyncConfigService', 'storeService'];

	function leanSyncAddField($rootScope, $scope, $filter, $timeout, $compile,
			$uibModal, leanSyncConfigService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.fieldTypes = [{id: 'Boolean', text: 'Boolean'},{id: 'Date', text: 'Date'},{id: 'Float', text: 'Float'},{id: 'Integer', text: 'Integer'},{id: 'String', text: 'String'}];
		vm.leanSyncTables = [];
		vm.saveSettings = saveSettings;
		vm.hasErrors = hasErrors;
		vm.field = {};
		
		leanSyncConfigService.getTables(adminConfig.factory.id)
		.then(function(data) {
			if (data) {
				vm.leanSyncTables = data;
			}
		});

		function getFullTableNameByNdx(tableNdx) {
			var fullTableName = null;
			for (var i = 0; i < vm.leanSyncTables.length; i++) {
				if (vm.leanSyncTables[i].tableNdx === tableNdx) {
					fullTableName = vm.leanSyncTables[i].fullTableName;
					break;
				}
			}
			return fullTableName;
		}

		function clearFields() {
			vm.field.fullTableName = null;
			vm.field.tableNdx = null;
			vm.field.fieldType = null;
			vm.field.fieldName = '';
			vm.field.leanSyncFieldName = '';
			vm.field.defaultValue = '';
		}

		function saveSettings() {
			vm.field.fullTableName = getFullTableNameByNdx(vm.field.tableNdx);
			if (vm.field.fullTableName != null) {
				leanSyncConfigService.saveLeanSyncField(vm.field, adminConfig.factory.id).then(function(message){
					clearFields();
				});
			}
		}

		function hasErrors() {
			return document.querySelectorAll('.has-error').length > 0;
		}
	}
})();
